import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "@/lib/content-defaults";

const links = [
  { to: "/", label: "Inicio" },
  { to: "/metodo", label: "Método CP" },
  { to: "/clases", label: "Clases" },
  { to: "/nosotros", label: "Nosotros" },
  { to: "/contacto", label: "Contacto" },
  { to: "/programa-kidstenia", label: "Kidstenia" },
] as const;

export function SiteNav() {
  const [open, setOpen] = useState(false);

  // Bug real (previo a esta sesión, no introducido por ningún cambio reciente): el panel del
  // menú móvil solo ocupaba su propio alto (la lista de links) sin tapar el resto de la
  // pantalla ni bloquear el scroll de atrás — si la página ya estaba desplazada hacia abajo al
  // abrir el menú, el contenido de esa parte de la página (ej. el footer) quedaba visible
  // detrás, mezclado con la lista. Al bloquear el scroll del body mientras el menú está
  // abierto, la página vuelve siempre arriba visualmente detrás del panel (que además ahora
  // cubre el alto completo restante, ver className de la <nav> de abajo).
  useEffect(() => {
    if (!open) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prevOverflow; };
  }, [open]);

  return (
    <>
    {/* El menú móvil (más abajo) NO puede vivir dentro de este <header>: backdrop-blur-md es un
        backdrop-filter, y un backdrop-filter en un ancestro crea un "containing block" nuevo
        para cualquier hijo position:fixed — ese hijo deja de posicionarse respecto a la
        pantalla y pasa a posicionarse respecto a ESTE <header> (que se autoajusta a su propio
        contenido, no al alto de la ventana). Por eso el panel fijo (fixed inset-x-0 top-16
        bottom-0) no cubría toda la pantalla y el contenido de la página se veía mezclado atrás
        (hallazgo real, reportado con captura). Sacándolo como hermano del <header> en vez de
        hijo, vuelve a posicionarse respecto al viewport real. */}
    <header className="fixed inset-x-0 top-0 z-50 border-b border-[var(--cp-line)] bg-black/80 backdrop-blur-md">
      <div className="cp-container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2" onClick={() => setOpen(false)}>
          {/* alt="" a propósito: el nombre de la marca ya va como texto visible al lado (el
              <span> de abajo), así que el logo es decorativo acá — el <Link> que envuelve a los
              dos ya tiene nombre accesible por ese texto (hallazgo real: alt repetido con texto
              visible adyacente). */}
          <span className="grid h-10 w-11 place-items-center rounded-lg bg-white p-1">
            <img src={LOGO_URL} alt="" decoding="async" className="h-full w-full object-contain" />
          </span>
          <span className="hidden min-[375px]:inline-block font-display text-sm tracking-[0.2em] text-white">
            CALISTENIA PROGRESIVA
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="font-mono text-xs uppercase tracking-[0.2em] text-white/70 transition hover:text-[var(--cp-cyan)]"
              activeProps={{ className: "font-mono text-xs uppercase tracking-[0.2em] text-[var(--cp-cyan)]" }}
              activeOptions={{ exact: l.to === "/" }}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <Link to="/contacto" className="hidden md:inline-flex cp-btn-primary !py-2.5 !px-4 !text-[0.65rem]">
          Agendar clase
        </Link>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Menú"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

    </header>

    {open && (
      <nav className="md:hidden fixed inset-x-0 top-16 bottom-0 z-40 overflow-y-auto border-t border-[var(--cp-line)] bg-black px-5 py-6 flex flex-col gap-4">
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            onClick={() => setOpen(false)}
            className="font-display font-bold text-2xl uppercase tracking-wide text-white"
            activeProps={{ className: "font-display font-bold text-2xl uppercase tracking-wide text-[var(--cp-cyan)]" }}
            activeOptions={{ exact: l.to === "/" }}
          >
            {l.label}
          </Link>
        ))}
        <Link to="/contacto" onClick={() => setOpen(false)} className="cp-btn-primary mt-4">
          Agendar clase
        </Link>
      </nav>
    )}
    </>
  );
}
